import { useCallback, useRef, useEffect } from 'react';
export function useParentIndicators(parentComment, parentCommentRef) {
    var commentElements = useRef({});
    var verticalIndicatorElements = useRef({});
    var setVerticalIndicatorRef = useCallback(function (commentId, element) {
        verticalIndicatorElements.current[commentId] = element;
    }, []);
    var setCommentRef = useCallback(function (commentId, element) {
        if (!element) {
            return;
        }
        commentElements.current[commentId] = element;
    }, []);
    var onCommentMouseOver = useCallback(function (commentId, parentId, isReplyingToParent) {
        if (!parentId ||
            !commentElements.current[commentId] ||
            !verticalIndicatorElements.current[commentId] ||
            isReplyingToParent) {
            return;
        }
        var parentNode = null;
        if (parentComment &&
            parentComment.commentId === parentId &&
            parentCommentRef) {
            parentNode = parentCommentRef.current;
        }
        else {
            parentNode = commentElements.current[parentId];
        }
        if (!parentNode) {
            return;
        }
        var commentTop = commentElements.current[commentId].getBoundingClientRect().top;
        var parentTop = parentNode.getBoundingClientRect().top;
        verticalIndicatorElements.current[commentId].style.height = commentTop - parentTop - 20 + "px";
    }, [parentComment, parentCommentRef]);
    useEffect(function () {
        if (parentComment && parentCommentRef) {
            setCommentRef(parentComment.commentId, parentCommentRef.current);
        }
    }, [parentComment, parentCommentRef, setCommentRef]);
    return { setVerticalIndicatorRef: setVerticalIndicatorRef, setCommentRef: setCommentRef, onCommentMouseOver: onCommentMouseOver };
}
//# sourceMappingURL=useParentIndicators.js.map